import { components, MenuListProps } from 'react-select';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { useEffect } from 'react';
import { FormType } from '../../../shared/models/form';
import PassengersController from './PassengersController';
import { validateAdults, validateChildren, validateInfants } from './passengersValidation';
import MenuItem from './MenuItem';
import { useTranslation } from 'react-i18next';
import useResizeObserver from '../useResizeObserver';

interface CustomMenuListProps {
  menuListProps: MenuListProps;
}

const CustomMenuList = ({ menuListProps }: CustomMenuListProps) => {
  const { control, trigger } = useFormContext<FormType>();
  const ref = useResizeObserver<HTMLDivElement>();

  useEffect(() => {
    void trigger(['adults', 'children', 'infants']);
  }, [trigger]);

  const { t } = useTranslation();

  const {
    fields: childrenFields,
    append: childrenAppend,
    remove: childrenRemove,
    update: childrenUpdate,
  } = useFieldArray({ control, name: 'childrenAges' });

  const {
    fields: infantsFields,
    append: infantsAppend,
    remove: infantsRemove,
    update: infantsUpdate,
  } = useFieldArray({ control, name: 'infantsAges' });

  return (
    <components.MenuList {...menuListProps} innerRef={ref}>
      <PassengersController fieldName="adults" rules={{ validate: validateAdults }} />
      <PassengersController
        fieldName="children"
        rules={{ validate: validateChildren }}
        append={() => childrenAppend({ age: 7 })}
        remove={() => childrenRemove(childrenFields.length - 1)}
      />
      <PassengersController
        fieldName="infants"
        rules={{ validate: validateInfants }}
        append={() => infantsAppend({ age: 1 })}
        remove={() => infantsRemove(infantsFields.length - 1)}
      />
      {childrenFields.length || infantsFields.length ? (
        <>
          <div className="px-4 py-2 bg-gray-100">{t('Enter the age at last day of the trip')}</div>
          <hr />
        </>
      ) : null}
      {childrenFields.map((field, index) => (
        <MenuItem
          key={field.id}
          text={`${t('Age')}, ${t('child')} ${index + 1}`}
          value={field.age}
          onMinusClick={() => childrenUpdate(index, { age: field.age - 1 })}
          onPlusClick={() => childrenUpdate(index, { age: field.age + 1 })}
          minusButtonDisabled={field.age < 3}
          plusButtonDisabled={field.age > 16}
        />
      ))}
      {infantsFields.map((field, index) => (
        <MenuItem
          key={field.id}
          text={`${t('Age')}, ${t('infant')} ${index + 1}`}
          value={field.age}
          onMinusClick={() => infantsUpdate(index, { age: field.age - 1 })}
          onPlusClick={() => infantsUpdate(index, { age: field.age + 1 })}
          minusButtonDisabled={field.age < 1}
          plusButtonDisabled={field.age >= 1}
        />
      ))}
    </components.MenuList>
  );
};

export default CustomMenuList;
